import React, { useEffect, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LandingPage from './pages/LandingPage';
import ProductsPage from './pages/ProductsPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import UserReviewsPage from './pages/UserReviewsPage';
import ProtectedRoute from './components/ProtectedRoute'; // ← add

import AppContext, { AppProvider } from './contexts/AppContext';
import { ThemeProvider } from './contexts/ThemeContext';

function AppWrapper() {
  const { dispatch } = useContext(AppContext);

  useEffect(() => {
    const handleCartCleared = () => {
      dispatch({ type: 'SET_CART', payload: [] });
    };
    window.addEventListener('cartCleared', handleCartCleared);
    return () => window.removeEventListener('cartCleared', handleCartCleared);
  }, [dispatch]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/reviews" element={<UserReviewsPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/admin" element={<AdminLoginPage />} />

    
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppProvider>
        <AppWrapper />
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;